import * as generalApi from '../../../general/api';

export function getCoverage(params) {
  return generalApi.getBrowserCoverage({ cloudType: 'vdc', ...params });
}

export function getCoverageCSV(params) {
  return generalApi.getBrowserCoverageCSV({ cloudType: 'vdc', ...params });
}
